import { silsilahAdminAuthRepository } from '@/projects/silsilah/repositories/adminAuthRepository';
import type { SilsilahAdminSession } from '@/projects/silsilah/models/adminAuth.model';

export const silsilahAdminAuthUsecase = {
  async login(googleToken: string): Promise<SilsilahAdminSession> {
    const tokens = await silsilahAdminAuthRepository.login(googleToken);
    const user = await silsilahAdminAuthRepository.profile(tokens.token);
    if (!user.roles.includes('ADMIN')) throw new Error('ADMIN_REQUIRED');
    return { ...tokens, project: 'silsilah', user };
  },

  async profile(token: string) {
    const user = await silsilahAdminAuthRepository.profile(token);
    if (!user.roles.includes('ADMIN')) throw new Error('ADMIN_REQUIRED');
    return user;
  },
};
